import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { store } from '../../../testStore';
import { TextInput } from '../../../lib/components/textInput';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* Result */
import Result from 'iotera-base/result';

/* Json */
import { safeGetWithType, safeGet, stringify, parse } from 'iotera-base/json';
import { isEmpty } from 'iotera-base/object';

/* Routes */
import { domainIsTenant as dit, S } from '../../../routes/routes';

/* Redux */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

/* Sagas Actions */
import { buildWBoundActions, buildWSelector } from '../../../redux/ducks';
import { actions as notificationActions } from '../../../redux/ducks/notification';

import { IoteraForm } from '../../../lib/components/form';
import { AreaInput } from '../../../lib/components/textInput';
import { SubViewHeaderStep } from '../../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import {
  setCallbackGlobal,
  unsetCallbackGlobal,
} from '../../../lib/components/callbackGlobal';
import { _TE } from 'iotera-base/text';
import { title } from '../../../lib/components/footer/material-dashboard-react';

const SUBMIT_DEVICE = 'SUBMIT_DEVICE';
const WKEY = 'DEVICE_ACTIVATION';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

function schema(plugins) {
  let pluginItem = [];
  for (let i = 0; i < plugins.length; i++) {
    pluginItem.push({
      type: 'string',
      enum: [stringify({
        plugin_key: safeGet(plugins, [i, 'emma_plugin_key']),
        application_plugin_id: safeGet(plugins, [i, 'emma_application_plugin_id']),
      })],
      title: safeGet(plugins, [i, 'emma_plugin_name']) + ' - ' + safeGet(plugins, [i, 'emma_application_plugin_id'])
    });
  }

  // Default value
  if (pluginItem.length === 0) {
    pluginItem.push({
      type: 'string',
      enum: ['-'],
      title: '-',
    });
  }

  return {
    definitions: {
      Plugin: {
        title: 'Plugin',
        type: 'string',
        anyOf: pluginItem,
      },
    },
    type: 'object',
    required: ['emma_plugin_select'],
    properties: {
      emma_plugin_select: { $ref: '#/definitions/Plugin', title: 'Plugin' },
      emma_plugin_details: { type: 'string', minLength: 1, title: 'Plugin Details', default: '{}' },
    },
  };
}

const uiSchema = {
  emma_plugin_details: {
    'ui:widget': props => {
      return (
        <AreaInput
          id="plugin_details"
          type="text"
          label="Plugin Details"
          textTooltip="Plugin Details"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
          areaHeight={200}
          {...props}
        />
      );
    },
    'ui:options': {
      label: false,
    },
  },
};

function buildCheckConfig(self) {
  const props = self.props;
  const domainIsTenant = dit(props);

  const wcallback = {
    started: function (id) {},
    finished: function (id, result) {
      if (result.code === Result.HTTP.OK) {
        self.goBack();
        props.showSingleNotification({ message: 'Sukses' });
      } else {
        props.showSingleNotification({ message: 'Gagal' });
      }
      self.setState({
        loading: false,
      });
    },
  };

  return {
    single_config: {
      [SUBMIT_DEVICE]: {
        wparam: {
          ...domainIsTenant,
          method: 'POST',
          path: '/service/web/device/emma/add',
          timeout: 120000,
        },
        wcallback,
      },
    },
  };
}

class EmmaActivation extends Component {
  constructor(props) {
    super(props);
    this.isTenant = dit(props);
    this.state = {
      activeTab: '1',
      loading: false,
      isDisabled: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const self = this;
    const props = this.props;

    // Callback global
    setCallbackGlobal(this.props);

    props.wInitRequestCall({
      wparam: {
        ...self.isTenant,
        path: '/service/web/device/emma/plugin/application/list',
      },
    });

    this.props.wSetConfig(buildCheckConfig(this));
  }

  componentWillUnmount() {
    const props = this.props;

    // Callback global
    unsetCallbackGlobal(props);
    props.wUnsetConfig({ key: WKEY });
  }

  handleSubmit(event) {
    const self = this;
    const { props, state } = self;
    const { isDisabled } = state;
    let storeValue = store.getState();
    let dataToShow = storeValue;
    let dataToSubmit = event.formData;
    let emmaPluginSelect = safeGetWithType(
      event,
      ['formData', 'emma_plugin_select'],
      '',
    );
    emmaPluginSelect =  parse(emmaPluginSelect);
    const emmaPluginDetails = safeGetWithType(
      event,
      ['formData', 'emma_plugin_details'],
      '',
    );

    const value = {
      emma_plugin_key: safeGet(emmaPluginSelect, 'plugin_key'),
      emma_application_plugin_id: safeGet(emmaPluginSelect, 'application_plugin_id'),
      emma_device_plugin_details: parse(emmaPluginDetails),
    };

    dataToSubmit = {
      ...dataToShow.device,
      ...value,
    };

    if (isDisabled) {
    } else {
      props.wSingleRequestCall({
        id: SUBMIT_DEVICE,
        body: dataToSubmit,
      });
      this.setState({
        isDisabled: true,
      });
    }
  }

  goBack() {
    this.props.history.push('..' + S + '..' + S + '_device_list_');
  }

  render() {
    const self = this;
    const props = self.props;
    const state = self.state;
    let storeValue = store.getState();
    let dataToShow = storeValue;
    if (isEmpty(dataToShow)) {
      self.goBack();
    } else {
      if ('device' in dataToShow) {
        if (isEmpty(dataToShow.device)) {
          self.goBack();
        } else {
          dataToShow = dataToShow.device;
        }
      } else {
        self.goBack();
      }
    }
    const { isDisabled, loading } = state;
    const spinner = (
      <div className="centeringItem">
        <ReactLoading type="bubbles" color="#ffffff" />
      </div>
    );
    return (
      <Loader show={loading} message={spinner}>
        <div className="view">
          <SubViewHeaderStep
            title="Tambah Perangkat"
            subTitle="Permohonan tambah perangkat Emma"
            steps={['Kategori', 'Informasi', 'Aktivasi']}
            activeStep={2}
          />
          <div className="io-container mt-12">
            {!loading && (
              <IoteraForm
                schema={schema(safeGet(props, ['info', 'plugins'], {}))}
                uiSchema={uiSchema}
                onSubmit={self.handleSubmit}
                formData={dataToShow}
              >
                {isDisabled ? (
                  <div className="button-right" style={{ marginTop: 10 }}></div>
                ) : (
                  <div className="button-right" style={{ marginTop: 10 }}>
                    <Button
                      variant="outlined"
                      size="large"
                      style={{ minWidth: '0%' }}
                      onClick={props.history.goBack}
                    >
                      Kembali
                    </Button>
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      type="submit"
                      style={{ marginLeft: 10, minWidth: '0%' }}
                    >
                      Simpan
                    </Button>
                  </div>
                )}
              </IoteraForm>
            )}
          </div>
        </div>
      </Loader>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    info: wSelector.getSoleInitMappedRPayload(state),
  };
};

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(EmmaActivation));
